<template>
  <auth-layout>
    <form @submit.prevent>
      <div class="row">
        <div class="col-md-12">
          <fg-input type="email"
            placeholder="Email"
            :class="{ 'form-group--error': $v.email.$error }"
            v-model="$v.email.$model"
            autofocus
            >
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <fg-input type="password"
            placeholder="Password"
            v-model="$v.password.$model"
            :class="{ 'form-group--error': $v.password.$error }"
            @keyupEnter="login">
            <div class="text-right">
              <router-link to="/forgot-password">Forgot your password?</router-link>
            </div>
          </fg-input>
        </div>
      </div>
      <div class="text-center">
        <p-button type="info" block
          :loading="isLoading"
          @click.native.prevent="login">
          <span v-if="isLoading">Logging in...</span>
          <span v-else>Login</span>
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </auth-layout>
</template>

<script>
import AuthLayout from '../../layout/AuthLayout.vue';
import { notify } from '../../services/notify';
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
    AuthLayout
  },
  data() {
    return {
      email: "",
      password: "",
      isLoading: false
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  created() {
    this.$store.cache.clear();
  },
  methods: {
    async login() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        notify().error('Please enter a valid email and password.')
        return;
      }

      this.isLoading = true;
      const success = await this.$store.dispatch('user/login', {
        email: this.email,
        password: this.password
      });

      if (success) {
        this.$store.cache.dispatch('user/fetchMe');
        let redirect = this.$route.query.redirect || '/';
        this.$router.push(redirect);
      }
      this.isLoading = false;
    }
  }
};
</script>
